<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formRfidSearchSetting" novalidate (ngSubmit)="searchRfids()" method="get" role="form">
            <tt-input ttRememberId="w_rfidsearch.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListRfids"></tt-list>
</tt-page>
